// extracted by mini-css-extract-plugin
export default {"space":"Space_space__grFPI","small":"Space_small__WwMAW","large":"Space_large__adfGn"};